// @ts-ignore
export const shortString = (text: string) => text.length > 15 ? text.match(/.{15,}?(?=\b)/)[0] + "...": text;  